import React, { useState, useEffect } from "react";
import Pagetrans from "./pagetrans";
import { Link } from "react-router-dom";

const Homepage = () => {
  const [hidebg, setHidebg] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setHidebg(false);
    }, 0);

    return () => {
      clearTimeout(t);
      setHidebg(true);
    };
  }, []);

  return (
    <main className={`home ${hidebg ? "hide-bg" : ""}`}>
      <Pagetrans className="container">
        <div className="home-image d-none d-md-block prf-image"></div>
        <div className="detail">
          <h6 className="hailing text-uppercase opensans-font d-md-none d-lg-block">
            Howdy !
          </h6>
          <h1 className="hailing text-uppercase poppins-font">
            <span>I'm </span> Emmanuel Menyaga
          </h1>
          <p className="opensans-font">
            I'm a Nigerian based front-end &amp; backend‑end developer
            (fullstack) focused on creative thinking, problem solving &amp;
            crafting clean &amp; user‑friendly experiences, I am passionate
            about building excellent software that improves the lives of those
            around me.
          </p>

          <Link
            className="btn btn-small btn-primary text-uppercase mb-1"
            to="/about"
          >
            More about me
          </Link>
          <Link
            className="btn btn-small btn-primary text-uppercase"
            to="/contact"
          >
            Get in touch
          </Link>
        </div>
      </Pagetrans>
    </main>
  );
};

export default Homepage;
